<bootstrap-popup [id]="id" [title]="'Signer le pdp et ajouter des signataires'" [displaySubject]="displaySubject" [modalSize]="'modal-lg'" [windowCloseButton]="true" >
	<form role="form" class="form-horizontal">
		<div class="form-group row selector-signataires" *ngIf="shouldSuggestSignatairesDialog()">
			<div class="col-sm-2"></div>
			<div class="col-sm-8" style="display: inline-flex;">
	            <button type="button" class="col-sm-3 btn btn-primary" (click)="openDialogSignataires()">
	            	Ajouter Signataire
	            </button>
	            <select class="col-sm-7 form-control entreprise-filter" [(ngModel)]="selectedEntrepriseSignataires">
	                <option [ngValue]="null"></option>
	                <option *ngFor="let entrepriseTLR of entreprises" [ngValue]="entrepriseTLR">{{ entrepriseTLR.nom }}</option>
	            </select>
	            <div class="col-sm-2"></div>
            </div>
            <div class="col-sm-2"></div>
        </div>
        
		<div class="form-group row header-signataires">
			<label class="col-sm-12 checkbox-inline">
				<span class="col-sm-4"></span>
				<span class="col-sm-4 header">Email</span>
				<span class="col-sm-2 header">Enveloppe DocuSign</span>
				<span class="col-sm-2 header header-force-sig">Signer</span>
			</label>
		</div>
		
		<div class="form-group row cocher-tous">
			<div class="col-sm-12">
				<div class="col-sm-12 checkbox-inline">
					<span class="col-sm-4 text-italic">Tous cocher</span>
					<span class="col-sm-4"></span>
		   			<span class="col-sm-2 cb-all-docusign">		   			
			   			<input type="checkbox" name="choixSigner_tous_ent" id="choixSigner_tous_ent" [disabled]="pdp.obsolete || pdp.expired"
							[(ngModel)]="allSendDocusign" (ngModelChange)="onChangeToutesDocusign($event)" />
					</span>
					<span class="col-sm-2 cb-all-forceSig">
		   			<input type="checkbox" name="choixSigner_tous" id="choixSigner_tous" 
						[(ngModel)]="allSignatairesSigned" (ngModelChange)="onChangeToutesSignatures($event)" />
					</span>
				</div>
			</div>
		</div>
		<div class="form-group row entreprises" *ngFor="let entrepriseId of entreprisesSignataireIds()">
			<div class="col-sm-12 block-ent">
				<div class="col-sm-12 checkbox-inline nom-entreprise">
					<span class="col-sm-4 nom-prenom">{{ referentielSignataires[entrepriseId].nomEntreprise }}</span>
		   			<span class="col-sm-4"></span>
		   			<span class="col-sm-2 cb-docusign">
			   			<input type="checkbox" name="choixSigner_{{entrepriseId}}" id="choixSigner_{{entrepriseId}}" 
			   			[(ngModel)]="referentielSignataires[entrepriseId].checkAllForDocusign"  [disabled]="pdp.obsolete || pdp.expired"
			   			(ngModelChange)="onChangeToutesDocuForEntreprise($event, entrepriseId)" />
			   			<i class="fa fa-eye" aria-hidden="true"><span>x</span></i>
					</span>
		   			<span class="col-sm-2"></span>
				</div>
				<div class="col-sm-12 checkbox-inline signataire" *ngFor="let signataire of referentielSignataires[entrepriseId].signataires; let index=index">
					<span class="col-sm-4 nom-prenom">{{ signataire.nom }} {{ signataire.prenom }}</span>
		   			<input id="emailSignataire_{{signataire.id}}" class="col-sm-4 email-signataire {{ signataire.emailStyle }}"
		   				name="emailSignataire_{{signataire.id}}" placeholder="Email du signataire" maxLength="200" 
		   				[disabled] = "!signataire.updatable" [(ngModel)]="signataire.email" type="email" (focusout)="onFocusLeaveEmail(signataire)"/>
		   			<span class="col-sm-2 cb-docusign">
			   			<input type="checkbox" name="choixSentToDocusign_{{signataire.id}}" 
			   				[disabled]="signataire.envelopeId || !signataire.email || signataire.emailStyle === 'error' || pdp.obsolete || pdp.expired" 
							id="choixSentToDocusign_{{signataire.id}}" [(ngModel)]="signataire.sentToDocusign"
							(ngModelChange)="onChangeDocuSign(signataire, $event)" />
							<i class="fa fa-eye {{ signataire.envelopeId ? '' : 'invisible' }} " (click)="viewEnveloppeDetail(signataire.envelopeId)">
								<span class="numero-envelope">{{ signataire.envelopeId && signataire.envelopeIndex ? signataire.envelopeIndex : 'x' }}</span>
							</i>
					</span>
		   			<span class="col-sm-2 cb-forceSig">
			   			<input type="checkbox" name="choixSigner_{{signataire.id}}" [disabled]="signataire.hasSignedEnvelope"
							id="choixSigner_{{signataire.id}}" [(ngModel)]="signataire.hasSigned"
							(ngModelChange)="onChangeSignature(signataire.id, $event)" />
					</span>
				</div>
			</div>
		</div>
		<div class="form-group row footer-signataires">
			<label class="col-sm-12"><span class="col-sm-12">&nbsp;</span></label>
		</div>
 		<div class="row">
			<div class="col-md-12">
				<div class="form-group text-center">
					<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">
						Fermer
					</button>
					<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveRequested()" 
						title = "{{ hasAtLeastOneSigner ? 'Envoyer l\'enveloppe vers DocuSign et sauvegarder' : 'Sauvegarder'}}"
						[disabled]="hasInvalidEmails()" *ngIf="!hasAtLeastOneSigner">
						Sauvegarder
					</button>
					<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveRequested()" 
						title = "{{ hasAtLeastOneSigner ? 'Envoyer l\'enveloppe vers DocuSign et sauvegarder' : 'Sauvegarder'}}"
						[disabled]="hasBlankOrInvalidEmails() || waitingForServer" *ngIf="hasAtLeastOneSigner">
						Envoyer et Sauvegarder
					</button>
				</div>
			</div>
		</div>
	</form>
</bootstrap-popup>

<signataire-dialog
	[id]="'popupSignatureDialog'"
	[initCommands]="editSignatairesCommands"
	(signatairesSelected)="onSignatairesSelected($event)"
	(closed)="onSignataireDialogClosed()"
	>
</signataire-dialog>

<docusign-enveloppe-dialog 
	[id]="'docusignEnvelopeDialogForSpecificPdps'" 
	[initCommands]="viewEnveloppeCommand"
	(onEnvelopeCancellation)="onEnvelopeCancellation()"
>
</docusign-enveloppe-dialog>
